import { render, staticRenderFns } from "./XinXiXiuGai.vue?vue&type=template&id=ebd1dd16&scoped=true"
import script from "./XinXiXiuGai.vue?vue&type=script&lang=js"
export * from "./XinXiXiuGai.vue?vue&type=script&lang=js"
import style0 from "./XinXiXiuGai.vue?vue&type=style&index=0&id=ebd1dd16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd1dd16",
  null
  
)

export default component.exports